
<div mat-dialog-title>Submit a Manual Adjustment for this Portfolio<button class="close" mat-button mat-dialog-close title="Cancel"><i class="material-icons clear" >clear</i></button></div>
<mat-dialog-content>
    <div class="block">
        <div class="manual-adj-left">
            <label >Rebalance Name</label>
        </div>
        <div class="manual-adj-right">
            <irb-validation-text-box #rebalanceNameField [(value)]="rebalanceName" max="70" regExp="^[a-zA-Z0-9\:\;\?\<\>\,\.\-\!\$\&\(\)\*\/ ]+$" invalidMessage="The value entered is not valid." width="90%" autofocus="true"></irb-validation-text-box>
        </div>
    </div>
    <div class="clear"></div>
    <div class="block">
        <div class="manual-adj-left">
            <label class="manual-adj-label">Portfolio</label>
        </div>
        <div class="manual-adj-right">
            <span>{{data.portfolioName}}</span>
        </div>
    </div>
    <div class="clear"></div>
    <div class="block">
        <div class="manual-adj-left">
            <label class="manual-adj-label">&nbsp;</label>
        </div>
        <div class="manual-adj-right">
            <span>Optional: Enter your own trade explanation below (e.g. "trade made to invest annual bonus").</span>
        </div>
    </div>
    <div class="clear"></div>
    <div class="block">
        <div class="manual-adj-left">
            <label class="manual-adj-label">Trade Explanation</label>
        </div>
        <div class="manual-adj-right">
            <irb-validation-text-box #tradeExplanationField [(value)]="data.tradeExplanation" max="70" regExp="^[a-zA-Z0-9\:\;\?\<\>\,\.\-\!\$\&\(\)\*\/ ]+$" invalidMessage="The value entered is not valid."  width="90%"></irb-validation-text-box>
        </div>
    </div>
    <div class="clear"></div>
    <mat-dialog-actions>
        <button  mat-dialog-close class="btn-medium-secondary">Cancel</button>
        <button (click)="continue()" class="btn-medium-primary">Continue</button>
    </mat-dialog-actions>
</mat-dialog-content>